import axios from 'axios';

export const moduleMifid = {
	actions: {
		pollRefill({ commit, dispatch }, isFromModal) {
			commit('setGlobalErrorMessage', '');
			commit('setPoolRefillLoader', true);

			dispatch('newLogoutTime');
			axios.post('Client/pollRefill?fromModal=' + isFromModal, null).then(
				(successResponse) => {
					const returnUrl = successResponse.data.data.returnUrl;
					const logOutAndRedirect =
						successResponse.data.data.logOutAndRedirect;
					if (logOutAndRedirect) {
						dispatch('logOut', {
							dontRedirect: true,
							redirectUrl: returnUrl,
						});
					} else {
						window.open(returnUrl, '_blank');
					}
					commit('setShowPoolInformationDialog', false);
					commit('setPoolRefillLoader', false);
				},
				(errorResponse) => {
					commit('setGlobalErrorMessage', errorResponse.data);
					commit('setShowPoolInformationDialog', false);
					commit('setPoolRefillLoader', false);
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				}
			);
		},
		acceptPollResultInfo({ commit, dispatch }) {
			commit('setPoolRefillLoader', true);
			dispatch('newLogoutTime');
			axios
				.post('Client/AcceptPollResultInfo', null)
				.then(() => {
					commit('setShowPoolInformationDialog', false);
					commit('setPoolRefillLoader', false);
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				})
				.catch(() => {
					commit('setShowPoolInformationDialog', false);
					commit('setPoolRefillLoader', false);
				});
		},

		closeMifidPopup({ commit, dispatch }) {
			commit('setPoolRefillLoader', true);
			dispatch('newLogoutTime');
			axios
				.post('Client/MifidPopupDisplay')
				.then(() => {
					commit('setShowPoolInformationDialog', false);
					commit('setPoolRefillLoader', false);
					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				})
				.catch(() => {
					commit('setShowPoolInformationDialog', false);
					commit('setPoolRefillLoader', false);
				});
		},
	},
};
